import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import { useParentHelperContext } from 'applications/GSP/pages/ParentHelper/providers/ParentHelperProvider/hooks';

import { OutlinedInputField } from './components/OutlinedInputField';
import { DEFAULT_VALUES, FieldsNames } from './constants';
import { useValidation } from './hooks';

import type { Fields } from './types';
import type { FC } from 'react';

export const Footer: FC = () => {
  const validationSchema = useValidation();
  const methods = useForm<Fields>({
    defaultValues: DEFAULT_VALUES,
    mode: 'onSubmit',
    resolver: yupResolver<Fields>(validationSchema),
  });
  const { sendQuestion, chatId } = useParentHelperContext();

  const handleSubmit = methods.handleSubmit(({ question }: Fields) => {
    sendQuestion({ question, chatId });

    methods.resetField('question');
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit}>
        <Box sx={{ m: { xs: 1, md: 2 }, mb: { xs: 2 } }}>
          <OutlinedInputField
            name={FieldsNames.Question}
            onSubmit={handleSubmit}
          />
        </Box>
      </form>
    </FormProvider>
  );
};
